import * as R from 'ramda';

export const getTopSkills = R.compose(
  R.slice(0, 5),
  R.sort((a, b) => R.propOr(0, 'isMandatory', b) - R.propOr(0, 'isMandatory', a)),
  R.sort((a, b) => R.propOr(0, 'level', b) - R.propOr(0, 'level', a)),
  R.flatten,
  R.props(['hard', 'soft', 'language'])
);

export const removeEmptySkills = (skills) => {
  return Object.entries(skills || {}).reduce((acc, [type, skills]) => {
    acc[type] = skills.filter((n) => n);
    return acc;
  }, {});
};

export const removeFormHookIdAttribute = (skills) => {
  return Object.entries(skills || {}).reduce((acc, [type, skills]) => {
    acc[type] = skills.map(({ formHookId: _ignored, ...skill }) => skill);
    return acc;
  }, {});
};
